import 'css-chunksrc/client/scenes/addPlanzoneResourceToProjects/projectsSelection/search/styles.scss';export default {
  "search": "_search_hofgi_1"
};